import { Flex, FlexProps } from '@modusign/design-system';
import { ReactNode } from 'react';

interface FullWidthButtonModalFooterProps extends FlexProps<'div'> {
  children: ReactNode;
}

export default function FullWidthButtonModalFooter({
  children,
  ...props
}: FullWidthButtonModalFooterProps) {
  return (
    <Flex flexDirection="column" gap={5} width="100%" {...props}>
      {children}
    </Flex>
  );
}
